// author Victor K.

export const getYTId:(str:string) => string = (str) => str.split('v=').pop()?.split('&')[0] || str;

export const getRTId:(str:string) => string = (str) => {
  const refactor = str.split('video/').pop()?.split('/')[0] || str;

  return `https://rutube.ru/play/embed/${refactor}`;
};
